import { action, computed, makeObservable, observable } from "mobx";
import { ExpandableKeys } from "./core";

import defectStatusIdCol from "../components/DefectValidator/data/defectStatusIdCol/defectStatusIdCol";

export const flatChildren = (arr = [], supervisor) =>
  arr.reduce((list, { children, ...e }) => {
    list.push(supervisor ? { supervisor, ...e } : e);
    if (children) list.push(...flatChildren(children, e.key));
    return list;
  }, []);
export class DefectTableFields {
  columns: Array<any> = [];

  visibleCols: ExpandableKeys;
  tempVisibleCols: ExpandableKeys | null = null;

  planned = false;

  constructor(columns, planned = false) {
    makeObservable(this, {
      columns: observable,
      tempVisibleCols: observable,
      initializeColumns: action,
      visibleColumns: computed,
      isSelectedAll: computed,
      fixedColumnsKeys: computed,
      allColumnsKeys: computed,
    });
    this.planned = planned;
    this.initializeColumns(columns);
  }

  initializeColumns = (columns) => {
    columns[0].render = defectStatusIdCol(this);
    const flattenColumns = flatChildren(columns, null);
    const keys = flattenColumns
      .filter((col) => col.visible)
      .map((col) => col.key)
      .filter((col) => col);

    this.visibleCols = new ExpandableKeys(keys);
    this.tempVisibleCols = new ExpandableKeys(keys);
    this.columns = [...columns];
  };

  get isSelectedAll() {
    return this.tempVisibleCols?.keys.length === this.allColumnsKeys.length;
  }

  get fixedColumnsKeys() {
    return this.columns.filter((col) => col.fixed).map((col) => col.key);
  }

  get allColumnsKeys() {
    const flattenColumns = flatChildren(this.columns, null);
    return flattenColumns.map((col) => col.key).filter((col) => col);
  }

  get visibleColumns(): Array<any> {
    const filterChildren = (child) => {
      if (child.children?.length > 0) {
        child.children = child.children.filter(filterChildren);
      }
      return this.visibleCols.keys.includes(child.key);
    };
    const cols = this.columns
      .map((col) => ({ ...col }))
      .filter((col) => {
        if (col.children?.length > 0) {
          col.children = col.children.filter(filterChildren);
        }
        return this.visibleCols.keys.includes(col.key);
      });
    return cols;
  }
}

export default DefectTableFields;
